import { ComponentProps } from "react";
import { Title } from "@radix-ui/react-dialog";
import { cn } from "@/utils/cn";

export const SheetTitle = ({
    className,
    ...props
}: ComponentProps<typeof Title>) => {
    return (
        <Title
            data-slot="sheet-title"
            className={cn("text-foreground font-semibold", className)}
            {...props}
        />
    )
}